import { useState, useEffect } from 'react'
import { Box, Grid } from '@mui/material'
import { useField } from 'formik'
import { useTranslation } from 'react-i18next'
import { AutoCompleteField } from 'src/components/shared/ui/form/fields'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'
import { useTipoMensajeContext } from 'src/contexts/TipoMensajeContext'
import { Orden as OrdenMaster } from 'src/enums/EscritosLegales'
import { FormField } from 'src/enums/Form'
import { useGetMaterias } from 'src/hooks/fetch/useCatalogoGeneralFilters'
import { Materia, Orden } from 'src/interfaces/Catalog'
import { FilterType, FilterCondition, queryFilter } from 'src/utils/queryFilter'

export default function MateriaOrDelitoAutocomplete(): JSX.Element | null {
  const [filteredMateriaAndDelitoItems, setMateriaAndDelitoFilteredItems] = useState<Materia[]>([])
  const materiaAndDelitoItems = useGetMaterias(FormField.DATOS_MATERIA) as Materia[]
  const { t } = useTranslation()
  const { isMonitorio } = useTipoMensajeContext()
  const [selectedOrden, setSelectedOrden] = useState<number | null>(null)

  const [orden] = useField<Orden>(
    `${FormField.ORGANO_DESTINO}.${FormField.ORGANO_DESTINO_ORDEN_JUDICIAL}`
  )

  // const claseRegistro = organo.value?.claseRegistro

  function addMateriaOptionCustomClasses(item: Materia) {
    if (item.seleccionable === '0') {
      return 'materia-no-seleccionable'
    }
    return item.codigo.length === 3 ? 'custom-materia-option--bold' : ''
  }

  function renderCustomOption(props, option) {
    props = {
      ...props,
      className: `${props.className} ${addMateriaOptionCustomClasses(option)}`
    }

    return (
      <Box sx={styles.autoCompleteOption} key={`${option.descripcion}-[${option.codigo}]`}>
        <li {...props}>{`${option.descripcion} [${option.codigo}]`}</li>
      </Box>
    )
  }

  function getMateriaFilteredItems() {
    const filters = [
      { key: 'codigoOrden', value: String(orden.value.orden), type: FilterType.EQUAL },
      { key: 'visibilidad', value: '1', type: FilterType.NOT_EQUAL }
    ]

    if (isMonitorio) {
      filters.push({ key: 'codigo', value: '102', type: FilterType.STARTS_WITH })
    }

    if (orden.value.orden !== selectedOrden) {
      const filterConfig: FilterCondition[] = [
        {
          condition: 'AND',
          filters
        }
      ]

      const filteredData = queryFilter(materiaAndDelitoItems, filterConfig)
      setMateriaAndDelitoFilteredItems(filteredData)
    }
  }

  function showMateria(orden) {
    const ordenConMateria = [
      OrdenMaster.ESPECIAL,
      OrdenMaster.CIVIL,
      OrdenMaster.CONTENCIOSO,
      OrdenMaster.SOCIAL
    ]
    if (ordenConMateria.includes(orden)) {
      return true
    }
    return false
  }

  useEffect(() => {
    if (materiaAndDelitoItems && materiaAndDelitoItems.length) {
      if (orden && orden.value) {
        setSelectedOrden(orden.value.orden)
        getMateriaFilteredItems()
      }
    }
    // eslint-disable-next-line
  }, [orden])

  // if (claseRegistro) {
  //   return <span>Clase registro:</span>
  // }

  // if (!claseRegistro && orden.value && showMateria(orden.value.orden)) {
  if (orden.value && showMateria(orden.value.orden)) {
    return (
      <Grid item xs={12} sm={4}>
        <AutoCompleteField
          id={FormField.DATOS_MATERIA}
          items={filteredMateriaAndDelitoItems}
          label={t('form.field.materia')}
          required
          itemName="descripcion"
          renderOptionCallback={renderCustomOption}
        />
      </Grid>
    )
  }

  // if (!claseRegistro && orden.value && orden.value.orden === OrdenMaster.PENAL) {
  if (orden.value && orden.value.orden === OrdenMaster.PENAL) {
    return (
      <Grid item xs={12} sm={4}>
        <AutoCompleteField
          id={FormField.DATOS_DELITO}
          items={filteredMateriaAndDelitoItems}
          label={t('form.field.delito')}
          itemName="descripcion"
          renderOptionCallback={renderCustomOption}
          required
        />
      </Grid>
    )
  }

  return null
}
